import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Link } from "react-router-dom";
import { Flame, Sparkles, BookOpen, ArrowRight } from "lucide-react";

export default function Today() {
  const { user } = useAuth();
  const [aff, setAff] = useState(null);
  const [affLoading, setAffLoading] = useState(true);
  const [habits, setHabits] = useState([]);
  const [journalCount, setJournalCount] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const [a, h, j] = await Promise.all([
          api.get("/affirmation/today"),
          api.get("/habits"),
          api.get("/journal"),
        ]);
        setAff(a.data.affirmation);
        setHabits(h.data);
        setJournalCount(j.data.length);
      } catch (e) { console.error(e); }
      finally { setAffLoading(false); }
    })();
  }, []);

  const bestStreak = habits.reduce((m, h) => Math.max(m, h.streak || 0), 0);
  const completedToday = habits.filter(h => h.completed_today).length;

  return (
    <div className="space-y-8" data-testid="today-page">
      <div className="rise-in">
        <p className="text-sm uppercase tracking-[0.2em] text-[#8A8D98]">Today · {new Date().toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" })}</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mt-2">Hello, {user?.name?.split(" ")[0] || "friend"}.</h1>
      </div>

      {/* Affirmation card */}
      <div className="soft-card relative overflow-hidden p-8 sm:p-10 rise-in rise-delay-1" data-testid="affirmation-card">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#F2CC8F]/40 blur-3xl" />
        <div className="relative">
          <span className="tag-chip bg-[#E07A5F]/12 text-[#E07A5F]">Today's affirmation</span>
          {affLoading ? (
            <div className="mt-4 h-8 bg-[#F2CC8F]/20 rounded animate-pulse w-3/4" />
          ) : (
            <p className="font-display text-3xl sm:text-4xl leading-snug mt-4 max-w-3xl">{aff}</p>
          )}
        </div>
      </div>

      {/* Bento */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link to="/app/habits" className="soft-card p-6 rise-in rise-delay-2" data-testid="tile-habits">
          <div className="flex items-center justify-between">
            <div className="w-10 h-10 rounded-2xl bg-[#E07A5F]/15 text-[#E07A5F] flex items-center justify-center"><Flame className="w-5 h-5" /></div>
            <ArrowRight className="w-4 h-4 text-[#8A8D98]" />
          </div>
          <p className="mt-6 text-sm uppercase tracking-widest text-[#8A8D98]">Best streak</p>
          <p className="font-display text-5xl mt-1">{bestStreak}<span className="text-xl text-[#8A8D98]"> days</span></p>
          <p className="mt-3 text-[#5b5f6e]">{completedToday} of {habits.length || 0} completed today</p>
        </Link>

        <Link to="/app/journal" className="soft-card p-6 rise-in rise-delay-3" data-testid="tile-journal">
          <div className="flex items-center justify-between">
            <div className="w-10 h-10 rounded-2xl bg-[#81B29A]/20 text-[#5a8b73] flex items-center justify-center"><BookOpen className="w-5 h-5" /></div>
            <ArrowRight className="w-4 h-4 text-[#8A8D98]" />
          </div>
          <p className="mt-6 text-sm uppercase tracking-widest text-[#8A8D98]">Entries</p>
          <p className="font-display text-5xl mt-1">{journalCount}</p>
          <p className="mt-3 text-[#5b5f6e]">Write a note to your future self</p>
        </Link>

        <Link to="/app/community" className="soft-card p-6 rise-in rise-delay-4" data-testid="tile-community">
          <div className="flex items-center justify-between">
            <div className="w-10 h-10 rounded-2xl bg-[#F2CC8F]/40 text-[#8A5A2B] flex items-center justify-center"><Sparkles className="w-5 h-5" /></div>
            <ArrowRight className="w-4 h-4 text-[#8A8D98]" />
          </div>
          <p className="mt-6 text-sm uppercase tracking-widest text-[#8A8D98]">Community</p>
          <p className="font-display text-3xl mt-1 leading-tight">Cheer someone on today.</p>
        </Link>
      </div>
    </div>
  );
}
